import { ipApi } from '../services/api';

/** Build deep-link URL for IPD admission pre-filled from an OP queue row or patient record. */
export function buildIpdAdmitLink({
  patientName,
  patientId,
  queueId,
  doctor,
  reason,
  diagnosis,
  phone,
  visitType,
}) {
  const p = new URLSearchParams();
  if (patientName) p.set('patient', patientName);
  if (patientId) p.set('patientId', patientId);
  if (queueId) p.set('queueId', queueId);
  if (doctor) p.set('doctor', doctor);
  if (reason) p.set('reason', reason);
  if (diagnosis) p.set('diagnosis', diagnosis);
  if (phone) p.set('phone', phone);
  if (visitType) p.set('visitType', visitType);
  return `/ipd/admit?${p.toString()}`;
}

export function genderFromCode(g) {
  if (!g) return 'Male';
  const u = String(g).toUpperCase();
  if (u === 'F' || u === 'FEMALE') return 'Female';
  if (u === 'M' || u === 'MALE') return 'Male';
  return g;
}

/** Load master patient record by UHID for OP → IP handoff. */
export async function fetchPatientProfile(patientId) {
  if (!patientId) return null;
  const res = await ipApi.getPatients(patientId, 15);
  const list = res?.patients || res?.items || [];
  return list.find((p) => p.patientId === patientId) || list[0] || null;
}

/** Active OP queue rows for a UHID — include today's visits and any linked source queue. */
export function opVisitsForPatient(queue, patientId, { sourceQueueId } = {}) {
  if (!queue?.length) return [];
  const today = new Date().toISOString().slice(0, 10);
  const weekAgo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
  return queue.filter((q) => {
    if (sourceQueueId && (q.queueId === sourceQueueId || q.id === sourceQueueId)) return true;
    if (!patientId || q.patientId !== patientId) return false;
    const vd = (q.visitDate || q.createdAt || '').slice(0, 10);
    if (!vd) return true;
    return vd >= weekAgo || vd === today;
  });
}

/** IP admissions for a UHID from the admissions list. */
export function ipAdmissionsForPatient(admissions, patientId) {
  if (!patientId || !admissions?.length) return [];
  return admissions.filter((a) => a.patientId === patientId);
}
